const isMobile = (state) => state.isMobile;
// const language = (state) => state.language;
const sortby = (state) => state.sortby;
const wrapperSize = (state) => state.wrapperSize;
const enableSound = (state) => state.enableSound;
const sessionExpired = (state) => state.sessionExpired;

export default {
  isMobile,
  // language,
  sortby,
  wrapperSize,
  enableSound,
  sessionExpired,
};
